import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PortfolioInvestmentsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PortfolioInvestmentsError', ...args);
    }
}
export default PortfolioInvestmentsError;
